import axios from "axios";
import { webAPI } from "../../api/Api";

export default {
  getUsers(request) {
    return axios.post("Admin/User/Users", request);
  },
  getRoles(body) {
    return axios.post("Admin/UserGroup/List", body);
  },
  getRolesList() {
    return axios.get("Admin/UserGroup");
  },
  getAllOrganizations(page = 1, count = 20, search, filterItems = null) {
    const body = {
      page: page,
      count: count,
      search: { text: search },
      filterItems
    };
    return axios.post("OrgStructure/Organizations", body);
  },
  getAllOrganizationsNonStrict(page = 1, count = 20, search) {
    const body = {
      page: page,
      count: count,
      search: { text: search, nonStrictMatch: true },
    };
    return axios.post("OrgStructure/Organizations", body);
  },
  getAllOrganizationsNonStrictRelatedOnly(page = 1, count = 20, search) {
    const body = {
      page: page,
      count: count,
      search: { text: search, nonStrictMatch: true },
    };
    return axios.post("OrgStructure/Organizations?relatedOnly=true", body);
  },
  saveUser(values) {
    return values.id
      ? axios.put(`Admin/User/${values.id}`, values)
      : axios.post("Admin/User", values);
  },
  deleteUser(userId) {
    return axios.delete(`Admin/User/${userId}`);
  },
  unDeleteUser(userId) {
    return axios.put(`Admin/User/${userId}/Undelete`);
  },
  getUserSettings(params) {
    return webAPI.get(`Admin/Account/Current/Settings`, { params });
  },
  saveUserSettings(params) {
    return webAPI.post(`Admin/Account/Current/Settings`, null, { params });
  },
  saveRole(values) {
    return values.id
      ? axios.put(`Admin/UserGroup/${values.id}`, values)
      : axios.post("Admin/UserGroup", values);
  },
  deleteRole(roleId) {
    return axios.delete(`Admin/UserGroup/${roleId}`);
  },
  getAccessMatrix() {
    return axios.get("Admin/UserGroup/AccessMatrix");
  },
  postAccessMatrix(payload) {
    return axios.post("Admin/UserGroup/SetAccessMatrix", payload);
  },
  getPermissions() {
    return axios.get("Admin/UserGroup/permissions");
  },
  getRolePermissions(userGroupId) {
    return axios.get(`Admin/UserGroup/${userGroupId}/permissions`);
  },
  postPermission(userGroupId, payload) {
    return axios.post(`Admin/UserGroup/${userGroupId}/permissions`, payload);
  },
  lockUser(userId, lockoutEnd) {
    const dt = lockoutEnd ? `?lockoutEnd=${lockoutEnd}` : "";
    return axios.post(`Admin/User/lock/${userId}${dt}`);
  },
  unlockUser(userId) {
    return axios.post(`Admin/User/unlock/${userId}`);
  },
  getUserHistory(userId) {
    return axios.get(`Admin/User/GetHistory/${userId}`);
  },
  getIntegrationLogs(request) {
    return axios.post(`Logging/SearchIntegrationLogs`, request);
  },
  getRoutes(values) {
    return axios.post(`Admin/Route/Search`, values);
  },
  postRoute(data) {
    return axios.post(`Admin/Route`, data);
  },
  putRoute(data) {
    return axios.put(`Admin/Route`, data);
  },
  deleteRoute(id) {
    return axios.delete(`Admin/Route/${id}`);
  },
  getEntityApprovalState(entityName, entityId) {
    return axios.get(`admin/route/current/${entityName}/${entityId}`);
  },
  getEntityApprovalHistory(entityName, entityId) {
    return axios.get(`admin/route/StatusHistory/${entityName}/${entityId}`);
  },
  getEntityStateList(entityName) {
    return axios.get(`admin/route/EntityState/${entityName}/List`);
  },
  sendEntityToApproval(data) {
    return axios.post(`admin/route/PassStep/`, data);
  },
  startAgreement(entityName, entityId) {
    return axios.post(
      `admin/route/StartAgreement/${entityName}/${entityId}`,
      {},
    );
  },
  cloneRole(payload) {
    return axios.post("Admin/UserGroup/Clone", payload);
  },
};
